import React from 'react';
import PropTypes from 'prop-types';

function Overlay() {
  return (
    <div
      className="overlay"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
      }}
    />
  );
}

function Hero({
  children, image, height, overlay,
}) {
  const styles = {
    backgroundImage: `url(${image})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: height,
    maxHeight: '800px',
    width: '100%',
    // backgroundAttachment: 'fixed',
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ ...styles, position: 'relative' }}>
      {overlay && <Overlay overlay={overlay} />}
      {children}
    </div>
  );
}

Hero.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node]),
  image: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  overlay: PropTypes.bool,
};
Hero.defaultProps = {
  children: [],
  image: '',
  height: 100,
  overlay: false,
};

export default Hero;
